import React from 'react'
import SuggestTitleForm from './SuggestTitleForm'

const SuggestTitleContent = ({
  showRequestFormContent,
  setShowRequestFormContent,
}) => {
  return (
    <>
      {!showRequestFormContent && (
        <p>
          Thanks again for your input! We&apos;ll email you if we publish this
          Study Guide.
        </p>
      )}
      {showRequestFormContent && (
        <>
          <p>
            Looking for a title we haven&apos;t covered yet? Provide the details
            here, so we can add it to our requested Study Guides list.
          </p>
          <SuggestTitleForm
            setShowRequestFormContent={setShowRequestFormContent}
          />
        </>
      )}
    </>
  )
}

export default SuggestTitleContent
